import Vue from 'vue';
import whitelistsCreateAddress from './components/createAddress/index.vue';
import whitelistsEditAddress from './components/editAddress/index.vue';
import { AsideModes } from '@/components/pages/whitelists/main/interfaces';
export default Vue.extend({
    name: 'whitelistsAside',
    props: {
        secretCodeExist: {
            type: Boolean,
            required: true
        },
        haveSelected: {
            type: Boolean,
            required: true
        },
        selectedItem: {
            type: Object,
            required: true
        },
        asideMode: {
            type: String,
            required: true
        },
        availableNetworks: {
            type: Array,
            required: true
        },
        walletsList: {
            type: Array,
            required: true
        }
    },
    data: () => ({
        mode: AsideModes.default
    }),
    watch: {
        asideMode(v) {
            this.mode = v;
        }
    },
    methods: {
        handleClickCreateAddress() {
            const vm = this;
            vm.$emit('changeAsideMode', 'create');
            vm.mode = AsideModes.create;
        },
        handleCancelCreate() {
            const vm = this;
            vm.mode = AsideModes.default;
        }
    },
    components: {
        whitelistsCreateAddress,
        whitelistsEditAddress
    }
});
